import { Components, Theme } from '@mui/material/styles';

import { CheckboxCheckedIcon, CheckboxIcon } from 'src/components/icons';

const MuiCheckbox: Components<Theme>['MuiCheckbox'] = {
  defaultProps: {
    checkedIcon: <CheckboxCheckedIcon style={{ fontSize: 16 }} />,
    icon: <CheckboxIcon style={{ fontSize: 16 }} />,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      '&:hover': {
        backgroundColor: 'transparent',
        color: theme.palette.primary.main,
      },
      '&.Mui-checked&:hover': {
        backgroundColor: 'transparent',
      },
    }),
    colorPrimary: ({ theme }) => ({
      color: theme.palette.primary.main,
    }),
  },
};

export default MuiCheckbox;
